<template>
    <div class="date-selector-inline">
        <a-select v-model="input" style="width: 100%">
            <a-select-option :value="'today'">{{ $t("chatWindow.today") }}</a-select-option>
            <a-select-option :value="'yesterday'">{{ $t("chatWindow.yesterday") }}</a-select-option>
            <a-select-option :value="'last7'">{{ $t("chatWindow.thisWeek") }}</a-select-option>
            <a-select-option :value="'last30'">{{ $t("chatWindow.last30Days") }}</a-select-option>
            <a-select-option :value="'this-month'">{{ $t("chatWindow.thisMonth") }}</a-select-option>
            <a-select-option :value="'last-month'">{{ $t("chatWindow.lastMonth") }}</a-select-option>
            <a-select-option :value="'custom'">{{ $t("chatWindow.custom") }}</a-select-option>
        </a-select>
        <a-range-picker v-if="input === 'custom'" v-model="cloneValue" show-time />
    </div>
</template>

<script>
export default {
    name: "DateSelectorInline",
    props: {
        value: {
            type: Object,
            default: () => null,
        },
    },
    data: () => ({
        input: "custom",
        cloneValue: null,
        staticDates: ["today", "yesterday", "last7", "last30", "this-month", "last-month"],
    }),
    mounted() {
        if (this.staticDates.includes(this.value)) {
            this.input = this.value;
        }
        this.cloneValue = this.value;
    },
    watch: {
        cloneValue() {
            this.$emit("input", this.cloneValue);
        },
        input() {
            this.cloneValue = null;
            const isCustom = !this.staticDates.includes(this.input);
            if (!isCustom) {
                this.cloneValue = this.input;
            }
        },
        value() {
            this.cloneValue = this.value;
        },
    },
};
</script>
<style scoped>
.date-selector-inline {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;
}
</style>
